<template>
  <div >
    <strong>{{productName}}</strong>
    <el-popover
      placement="top"
      :title="$t('products.additionnalInformation')"
      width="300"
      trigger="hover">
      <div v-for="(cf, index) in customFields">
        <span class="fs-14">{{$t('purchase_orders.lines.customFields.'+cf.code)}}</span><span class="fs-14">{{getCustomFieldValue(index,cf)}}</span>
      </div>
      <el-button slot="reference" type="text" v-if="customFields!=null && customFields.length>0"><i class="el-icon-info"></i></el-button>
    </el-popover>

    <span class="fs-12 secondary-text"><br>{{sku}}</span>
    <span v-if="isInventoryProduct">
      <br>
      <UnitFormatVolumeLabel
        :unit="product.unit"
        :uvc="product.uvc"
        :format="product.format"
        :volume="product.volume" />
    </span>
    <span v-if="reference" class="fs-14 secondary-text"><br>{{reference}}</span>
    <span v-if="description" class="fs-14 secondary-text"><br>{{description}}</span>
  </div>
</template>
<script>
import productUtils from '@/utils/portaus-utils';
import { mapActions, mapState, mapGetters } from 'vuex';
import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel';
export default {
  name: 'product-item-definition',
	props: {
    product: {
      type: Object,
      default : null,
    },
    sku : String,
    product_unit : Number,
    product_uvc : Number,
    reference  : String,
    description : String,

    customFields : {
      type : Array
    }
	},
  data() {
    return {

    };
  },
  components: {
    UnitFormatVolumeLabel,
  },
	methods: {
    getUnitFormatted(unit){
			return productUtils.getFormattedUnit_i18n(unit);
		},
    getCustomFieldValue(index,customField){
      if(this.purchaseOrderLinesCustomFieldsDefinition[index]!=null){
        if(this.purchaseOrderLinesCustomFieldsDefinition[index].value.code==customField.code && this.purchaseOrderLinesCustomFieldsDefinition[index].value.type=="list"){
          return this.purchaseOrderLinesCustomFieldsDefinition[index].value.values[this.$i18n.locale][customField.value];
        }else{
          return customField.value;
        }
      }
    },
    ...mapActions('controlData',['fetchPurchaseOrderLineCustomFieldsDefinition'])
	},
  computed : {
    vintage () {
      const vintage =  _.filter(this.customFields, cf => cf.code === 'VINTAGE');
      return _.get(_.head(vintage), 'value');
    },
    productName () {
      if (this.vintage != null) {
        return `${_.get(this.product, 'name')} ${this.vintage}`;
      }
      if (_.get(this.product, 'extendedName') != null) {
        return _.get(this.product, 'extendedName')
      }
      return _.get(this.product, 'name');
    },
    productType () {
      return _.get(this.product, 'type');
    },
    isInventoryProduct () {
      return this.productType === 1;
    },
    ...mapState('controlData',['purchaseOrderLinesCustomFieldsDefinition'])
  },
  mounted (){
    return this.fetchPurchaseOrderLineCustomFieldsDefinition();
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';




</style>
